import api from './index'
import type { ApiResponse } from '@/types'

/**
 * 水印相关接口
 */
export const watermarkApi = {
  // 获取品牌水印上传配置规则
  findBrandWatermarkRules: (params?: any): Promise<ApiResponse<any>> =>
    api.get('/api-algorithm/watermark/findBrandWatermarkRules', { params }),

  // 品牌水印添加
  addBrandWatermark: (data: any): Promise<ApiResponse<any>> =>
    api.post('/api-algorithm/watermark/addBrandWatermark', data),
}
